/**
 * OSM 小類（主標籤）白線圖形 — 地圖 POI 圓點用
 * 與畫布 poi-legend 的 SUB_GLYPH 對齊（67 類）
 */

/** @type {Record<string, string[]>} */
export const POI_KIND_GLYPH_PATHS = {
    "amenity=restaurant": [
        "M8 4v7",
        "M6 4h4",
        "M8 11v9",
        "M15 4c2 2 2 4 0 6v10"
    ],
    "amenity=cafe": [
        "M8 9h8v5a4 4 0 0 1-8 0z",
        "M16 11h2a2 2 0 0 1 0 4h-2",
        "M9 20h6"
    ],
    "amenity=fast_food": [
        "M6 10c0-3 12-3 12 0",
        "M6 13h12",
        "M7 16c0 2 10 2 10 0"
    ],
    "shop=beverages": [
        "M10 3h4v3l2 3v11H8V9l2-3z"
    ],
    "shop=bakery": [
        "M5 15c0-4 14-4 14 0v3H5z",
        "M8 15v-2",
        "M12 15v-2",
        "M16 15v-2"
    ],
    "shop=tea": [
        "M8 11h7v4a3.5 3.5 0 0 1-7 0z",
        "M15 13h2.2a1.8 1.8 0 0 1 0 3.2H15",
        "M10 7c.6 1 0 2 .8 2.6",
        "M13 7c.6 1 0 2 .8 2.6"
    ],
    "amenity=ice_cream": [
        "M9 8a3 3 0 0 1 6 0",
        "M9 8l3 13 3-13"
    ],
    "amenity=bar": [
        "M8 3h8l-1.2 6a2.8 2.8 0 0 1-5.6 0z",
        "M12 12v6",
        "M9 20h6"
    ],
    "amenity=food_court": [
        "M3 9h7v3a3 3 0 0 1-6 0V9z",
        "M14 9h7v3a3 3 0 0 1-6 0V9z"
    ],
    "amenity=pub": [
        "M7 6h8v9a4 4 0 0 1-8 0z",
        "M15 8h3a2 2 0 0 1 0 4h-3"
    ],
    "amenity=clinic": [
        "M12 5v14",
        "M5 12h14"
    ],
    "amenity=pharmacy": [
        "M10 3h4v3l2 2v12H8V8l2-2z",
        "M12 11v5",
        "M10 13.5h4"
    ],
    "amenity=dentist": [
        "M8 9c0-3 8-3 8 0 1 2 2 3 2 6 0 3-2 6-4 6s-1-3-2-3-1 3-2 3-4-3-4-6c0-3 1-4 2-6z"
    ],
    "shop=chemist": [
        "M9 8h6l-1 12H10z",
        "M10 8V5h4v3",
        "M12 12v4",
        "M10.5 14h3"
    ],
    "amenity=hospital": [
        "M6 20V9l6-4 6 4v11",
        "M10 20v-5h4v5",
        "M12 10v4",
        "M10 12h4"
    ],
    "amenity=doctors": [
        "M12 5a7 7 0 1 0 0 14 7 7 0 0 0 0-14z",
        "M12 8v8",
        "M8 12h8"
    ],
    "leisure=pitch": [
        "M12 4a8 8 0 1 0 0 16 8 8 0 0 0 0-16z",
        "M12 4c2 3 2 13 0 16",
        "M12 4c-2 3-2 13 0 16",
        "M5 9h14",
        "M5 15h14"
    ],
    "leisure=park": [
        "M12 21V12",
        "M12 12c-4 0-6 3-6 5 4 0 6-2 6-5z",
        "M12 12c4 0 6 3 6 5-4 0-6-2-6-5z",
        "M12 7c-2 0-3 2-3 2h6s-1-2-3-2z"
    ],
    "leisure=garden": [
        "M12 14v7",
        "M12 11a1.6 1.6 0 1 0 .1 0",
        "M12 9c-2-3-5-1-3 1",
        "M12 9c2-3 5-1 3 1",
        "M9 13c-3 1-2 4 1 3",
        "M15 13c3 1 2 4-1 3"
    ],
    "leisure=playground": [
        "M4 5h16",
        "M8 5l-2 9",
        "M16 5l2 9",
        "M5 14h5",
        "M14 14h5"
    ],
    "tourism=museum": [
        "M4 10l8-5 8 5",
        "M6 10v8",
        "M12 10v8",
        "M18 10v8",
        "M4 18h16"
    ],
    "leisure=track": [
        "M8 7h8a5 5 0 0 1 0 10H8a5 5 0 0 1 0-10z",
        "M10 12h4"
    ],
    "leisure=sports_centre": [
        "M4 20V10l8-5 8 5v10",
        "M4 20h16",
        "M12 12a2.2 2.2 0 1 0 .1 0"
    ],
    "leisure=fitness_centre": [
        "M4 10v4",
        "M7 7v10",
        "M7 12h10",
        "M17 7v10",
        "M20 10v4"
    ],
    "tourism=theme_park": [
        "M4 19 L12 6 L20 19",
        "M12 6v13",
        "M8 19h8"
    ],
    "tourism=zoo": [
        "M7 8 L5 4",
        "M17 8l2-4",
        "M8 11a1.4 1.4 0 1 0 .1 0",
        "M16 11a1.4 1.4 0 1 0 .1 0",
        "M8 15c1.2 2 6.8 2 8 0"
    ],
    "amenity=school": [
        "M3 11l9-5 9 5-9 5z",
        "M7 13v4c2.2 1.2 7.8 1.2 10 0v-4"
    ],
    "amenity=kindergarten": [
        "M4 14h6v6H4z",
        "M12 9h8v11h-8z"
    ],
    "amenity=library": [
        "M4 7c3 2 5 2 8 0 3 2 5 2 8 0v11c-3 2-5 2-8 0-3 2-5 2-8 0z",
        "M12 7v11"
    ],
    "amenity=prep_school": [
        "M14 3l6 6-8 8H6v-6z",
        "M12 5l6 6"
    ],
    "amenity=driving_school": [
        "M3 14l2-5h14l2 5v4H3z",
        "M7 18a1.4 1.4 0 1 0 .1 0",
        "M17 18a1.4 1.4 0 1 0 .1 0"
    ],
    "amenity=university": [
        "M3 8l9-4 9 4",
        "M6 8v9",
        "M10 8v9",
        "M14 8v9",
        "M18 8v9",
        "M3 17h18"
    ],
    "amenity=music_school": [
        "M9 17a2 2 0 1 0 .1 0",
        "M11 17V6l7 2v7",
        "M18 15a2 2 0 1 0 .1 0"
    ],
    "amenity=college": [
        "M6 8h12v9H6z",
        "M6 8c0-2 12-2 12 0",
        "M9 12h6"
    ],
    "amenity=language_school": [
        "M4 5h16v9H9l-3 3v-3H4z",
        "M10 12l2-5 2 5",
        "M11 10.5h2"
    ],
    "amenity=cram_school": [
        "M5 7h14v4H5z",
        "M6 12h12v4H6z",
        "M8 17h8"
    ],
    "shop=supermarket": [
        "M6 6h2l2 11h9",
        "M10 17h8l2-8H9",
        "M11 20a1.2 1.2 0 1 0 .1 0",
        "M17 20a1.2 1.2 0 1 0 .1 0"
    ],
    "shop=clothes": [
        "M12 6a1.5 1.5 0 1 0 .1 0",
        "M12 8 L6 12h12z",
        "M8 12l-2 7h12l-2-7"
    ],
    "shop=electronics": [
        "M9 3v4",
        "M15 3v4",
        "M8 7h8v6a4 4 0 0 1-8 0z",
        "M12 17v4"
    ],
    "amenity=marketplace": [
        "M3 10l3-5h12l3 5",
        "M3 10h18v2H3z",
        "M6 12v7",
        "M18 12v7",
        "M6 19h12"
    ],
    "shop=books": [
        "M6 4h12v16H6z",
        "M9 8h6",
        "M9 12h6"
    ],
    "shop=gift": [
        "M5 11h14v8H5z",
        "M12 11v8",
        "M5 11V8h14v3",
        "M12 8c-2-3-5-1-3.2 1",
        "M12 8c2-3 5-1 3.2 1"
    ],
    "shop=shoes": [
        "M4 16c2-1 5-5 7-5h5l4 3v2H4z"
    ],
    "shop=mall": [
        "M3 20V11l4-3 5 3 5-3 4 3v9",
        "M3 20h18",
        "M8 20v-4h3v4"
    ],
    "shop=department_store": [
        "M5 20V5h14v15",
        "M5 20h14",
        "M8 8h2",
        "M12 8h2",
        "M16 8h2",
        "M8 12h2",
        "M12 12h2",
        "M16 12h2",
        "M10 20v-4h4v4"
    ],
    "amenity=place_of_worship": [
        "M4 20V11",
        "M20 20V11",
        "M3 11h18",
        "M2 8h20",
        "M12 8V4",
        "M8 11v4",
        "M16 11v4"
    ],
    "amenity=community_centre": [
        "M4 12 L12 5 L20 12",
        "M6 12v8h12v-8",
        "M10 20v-5h4v5"
    ],
    "amenity=police": [
        "M12 3l7 3v6c0 4-3 7-7 8-4-1-7-4-7-8V6z"
    ],
    "amenity=fire_station": [
        "M12 20c-4 0-6-3-5-7 1-3 3-3 3-7 2 3 2 4 4 4 0-2 1-3 2-4 1 3 4 4 4 7 0 4-3 7-8 7z"
    ],
    "amenity=townhall": [
        "M4 9l8-5 8 5",
        "M6 10v7",
        "M12 10v7",
        "M18 10v7",
        "M4 18h16"
    ],
    "amenity=courthouse": [
        "M12 3v16",
        "M7 20h10",
        "M5 8h14",
        "M5 8 L2 14h6z",
        "M19 8l-3 6h6z"
    ],
    "amenity=bank": [
        "M4 9l8-5 8 5H4z",
        "M6 11v6",
        "M12 11v6",
        "M18 11v6",
        "M4 18h16"
    ],
    "amenity=post_box": [
        "M8 3h8v17H8z",
        "M8 8h8",
        "M10 12h4"
    ],
    "amenity=post_office": [
        "M4 7h16v11H4z",
        "M4 7l8 6 8-6"
    ],
    "amenity=atm": [
        "M6 5h12v14H6z",
        "M6 9h12",
        "M9 13h4"
    ],
    "highway=bus_stop": [
        "M6 5h12v10H6z",
        "M9 17a1.4 1.4 0 1 0 .1 0",
        "M15 17a1.4 1.4 0 1 0 .1 0",
        "M9 8h2",
        "M13 8h2"
    ],
    "amenity=parking": [
        "M8 4h6a4 4 0 0 1 0 8H8z",
        "M8 4v16"
    ],
    "amenity=bicycle_rental": [
        "M7 17a3 3 0 1 0 .1 0",
        "M17 17a3 3 0 1 0 .1 0",
        "M7 17 L12 8h4l1 9",
        "M12 8h3"
    ],
    "amenity=motorcycle_parking": [
        "M6 16a2.2 2.2 0 1 0 .1 0",
        "M17 16a2.2 2.2 0 1 0 .1 0",
        "M6 16l4-6h6l2 4",
        "M9 10h4"
    ],
    "amenity=parking_space": [
        "M6 4v16",
        "M12 4v16",
        "M18 4v16",
        "M6 20h12"
    ],
    "amenity=bicycle_parking": [
        "M4 18h16",
        "M7 18V8",
        "M12 18V6",
        "M17 18V8",
        "M7 8h10"
    ],
    "railway=subway_entrance": [
        "M12 4v10",
        "M7 10l5 8 5-8"
    ],
    "amenity=bus_station": [
        "M4 6h16",
        "M6 6v3",
        "M18 6v3",
        "M7 9h10v6H7z",
        "M9 15v2",
        "M15 15v2"
    ],
    "railway=station": [
        "M7 4h10v12H7z",
        "M7 10h10",
        "M9 16l-2 4",
        "M15 16l2 4",
        "M9 7h2",
        "M13 7h2"
    ],
    "amenity=charging_station": [
        "M13 3 L7 13h5l-1 8 8-11h-5z"
    ],
    "amenity=taxi": [
        "M4 14l2-4h12l2 4v4H4z",
        "M8 10l1-3h6l1 3",
        "M7 18a1.3 1.3 0 1 0 .1 0",
        "M17 18a1.3 1.3 0 1 0 .1 0"
    ],
    "shop=convenience": [
        "M4 10h16v9H4z",
        "M4 10l2-4h12l2 4",
        "M10 14h4v5H10z"
    ]
};

/** 與 poi-mapper KIND_DISPLAY_ALIAS 對齊：合併小類共用主類圖 */
export const POI_KIND_GLYPH_ALIAS = {
    'amenity=doctors': 'amenity=clinic',
    'amenity=pub': 'amenity=bar',
    'leisure=garden': 'leisure=park',
    'amenity=cram_school': 'amenity=prep_school'
};

export function poiKindGlyphPaths(kind) {
    const raw = String(kind || '').trim().toLowerCase();
    if (!raw) return null;
    const key = POI_KIND_GLYPH_ALIAS[raw] || raw;
    const paths = POI_KIND_GLYPH_PATHS[key];
    return Array.isArray(paths) && paths.length ? paths : null;
}

/** 回傳 path 元素字串（已含 <path d=...>），無小類圖則 null */
export function poiKindGlyphInner(kind) {
    const paths = poiKindGlyphPaths(kind);
    if (!paths) return null;
    return paths.map((d) => `<path d="${d}"/>`).join('');
}

export const POI_KIND_GLYPH_COUNT = Object.keys(POI_KIND_GLYPH_PATHS).length;
